<template>
  <div class="exchangeConfirmationView">
    <div class="exchangeConfirmationView__content">
      <div class="exchangeConfirmationView__content--heading">
        <h1>
          {{ translations.orderConfirmationHeading }}
        </h1>
      </div>
      <div class="exchangeConfirmationView__content--item">
        <h3 v-if="suppliedFormData">
          {{ translations?.orderConfirmationEmailLabel }}
        </h3>
        <span>{{ suppliedFormData?.emailAddress }}</span>
      </div>
      <div class="exchangeConfirmationView__content--item">
        <h3>{{ translations?.orderConfirmationOrderNumberLabel }}</h3>
        <span>{{ orderConfirmationResponse }}</span>
      </div>
      <div class="exchangeConfirmationView__content--item">
        <h3>{{ translations?.orderConfirmationDateLabel }}</h3>
        <span>{{ getOrderDate }}</span>
      </div>
    </div>
    <TheExchangeSidebar />
  </div>
</template>

<script src="./index.js"></script>

<style scoped lang="scss">
  @import './style.scss';
</style>
